<template>
  <div class="sampleDatePicker">
    <el-date-picker
      v-model="date"
      type="date"
      placeholder="날짜 선택"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd">
    </el-date-picker>
  </div>
</template>

<script>
export default {  
    name: 'sampleDatePicker',
    data() {
        return {
            date: '',
            pickerOptions: {
                disabledDate(time){
                    return time.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    }
};
</script>
